// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"vu_a bhc_b bhc_ux"};